'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

import { FallbackImage } from './FallbackImage';
import { IMG } from '../../imgPrefix';

interface Tournament {
  id: number;
  name: string;
  slug: string;
  image: string;
}

interface TournamentSliderProps {
  tournaments: Tournament[];
}

export function TournamentSlider({ tournaments }: TournamentSliderProps) {
  if (!tournaments.length) return null;

  return (
    <div className="tournament-slider-wrap">
      <Swiper
        modules={[Navigation, Autoplay]}
        navigation={true}
        grabCursor={true}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        slidesPerView={1}
        spaceBetween={16}
        breakpoints={{
          768: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        }}
        style={{
          padding: 0,
          backgroundColor: 'transparent',
          overflow: 'hidden',
        }}
      >
        {tournaments.map((t) => (
          <SwiperSlide
            key={t.id}
            style={{
              display: 'block',
              textAlign: 'left',
              height: 'auto',
              overflow: 'hidden',
            }}
          >
            <div className="box-wrapper">
              <div className="item">
                <div className="bg-yellow cutout-shape offer-sec bg-white">
                  <div className="cutout-inner">
                    <a href={`/sports/tournament/${t.slug}`}>
                      <FallbackImage
                        src={t.image}
                        fallbackSrc={`${IMG}/image/default-tournaments.jpg`}
                        alt={t.name}
                        className="img-fluid w-100"
                      />
                    </a>

                    <div className="Accommodation-data">
                      <div className="h4">
                        <a href={`/sports/tournament/${t.slug}`} className="text-black">
                          {t.name}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
